import { ComposeForm } from "components/widget/edit/compose_form";

export default ComposeForm();
